module.exports = __webpack_public_path__ + "static/media/up_grandine_logo.f1229b62.png";